// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"d8b50060","451":"68f826c1","551":"5a4e31c4"}[chunkId] + ".chunk.js";
};